import { render, staticRenderFns } from "./GameDevDisciplines.vue?vue&type=template&id=7e681968"
import script from "./GameDevDisciplines.vue?vue&type=script&lang=js"
export * from "./GameDevDisciplines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports